import Marquee from "react-fast-marquee";
import { clients } from "../data/site";
import SectionHeading from "./SectionHeading";

const getClientLogo = (name) => {
  if (name === "SRAVANTHI") return "/logos/sravanthi.png";
  if (name === "VISTA SPACES") return "/logos/vista-spaces.png";
  if (name === "HIRANANDANI") return "/logos/hiranandani.png";
  if (name === "KIMS HOSPITALS") return "/logos/kims.png";
  if (name === "LODHA") return "/logos/lodha.png";
  if (name === "MINERVA") return "/logos/minerva.png";
  if (name === "E11 HOMES") return "/logos/e11-homes.png";
  if (name === "ISTA HOMES") return "/logos/ista-homes.png";
  if (name === "GREENKO") return "/logos/greenko.png";
  if (name === "BIOLOGICAL E") return "/logos/biological-e.png";
  if (name === "HITEX") return "/logos/hitex.png";
  if (name === "GODREJ") return "/logos/godrej.png";
  if (name === "PRATHIMA") return "/logos/prathima.png";
  if (name === "G PULLA REDDY") return "/logos/g-pulla-reddy.png";
  if (name === "KLR PROPERTIES") return "/logos/klr-properties.png";
  if (name === "DOYEN") return "/logos/doyen.png";
  if (name === "L&W" || name === "XL&W") return "/logos/lw.png";
  if (name === "SRI GAYATHRI") return "/logos/sri-gayathri.png";
  if (name === "ARD ESTATES & PROJECTS" || name === "ARD ESTATES") return "/logos/ard-estates.png";
  return null;
};

export default function ClientsSection() {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-14">
        <SectionHeading
          eyebrow="Trusted by"
          title="The names building modern Hyderabad."
          description="More than 100 builders, architects, and institutional developers rely on us to manage their critical approvals pipeline."
          testId="clients-heading"
        />
      </div>

      <div className="marquee-mask">
        <Marquee speed={45} gradient={false} pauseOnHover>
          {clients.map((c, i) => {
            const logo = getClientLogo(c);
            return (
              <div
                key={`${c}-${i}`}
                data-testid={`client-logo-${i}`}
                className="mx-12 md:mx-16 flex items-center h-24 md:h-28"
              >
                {logo ? (
                  <img 
                    src={logo} 
                    alt={c} 
                    className="max-h-12 md:max-h-16 object-contain opacity-70 hover:opacity-100 hover:scale-105 transition-all duration-500 filter brightness-100" 
                  />
                ) : (
                  <span className="font-display text-2xl md:text-3xl tracking-[0.22em] text-white/70 hover:text-[#C96A2B] transition-colors duration-500">
                    {c}
                  </span>
                )}
              </div>
            );
          })}
        </Marquee>
      </div>

      <div className="marquee-mask mt-6">
        <Marquee speed={35} direction="right" gradient={false} pauseOnHover>
          {[...clients].reverse().map((c, i) => {
            const logo = getClientLogo(c);
            return (
              <div
                key={`${c}-r-${i}`}
                data-testid={`client-logo-r-${i}`}
                className="mx-12 md:mx-16 flex items-center h-20 md:h-24"
              >
                {logo ? (
                  <img 
                    src={logo} 
                    alt={c} 
                    className="max-h-10 md:max-h-12 object-contain opacity-60 hover:opacity-100 hover:scale-105 transition-all duration-500 filter brightness-100" 
                  />
                ) : (
                  <span className="font-display text-xl md:text-2xl tracking-[0.22em] text-white/60 hover:text-[#C96A2B] transition-colors duration-500">
                    {c}
                  </span>
                )}
              </div>
            );
          })}
        </Marquee>
      </div>
    </section>
  );
}
